import classNames from 'classnames';
import Icon from '../assets/file.svg';
import DeleteIcon from '../assets/delete.svg';
import { getFileExtension } from '../utils';
import s from './index.module.scss';

export const FilePreview = ({ name, onRemove }) => {
  const fileExtension = getFileExtension(name);

  return (
    <div className={s.wrapper}>
      <div className={s.icon}>
        <img src={Icon} width={24} height={24} alt="file" />
      </div>
      <div className={s.content}>
        <div className={classNames('f-body', s.name)}>{name.replace(`.${fileExtension}`, '')}</div>
        <div
          className="f-label"
          style={{ color: 'var(--Grey-500, #908A94)', textTransform: 'uppercase' }}
        >
          {fileExtension}
        </div>
      </div>
      <button type="button" className={s.btn_delete} onClick={onRemove}>
        <img src={DeleteIcon} width={24} height={24} alt="delete" />
      </button>
    </div>
  );
};
